import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';
import { TranslocoService } from '@jsverse/transloco';;
import { Cultures } from '../models/cultures.enum';

/**
 * This class is for intercepting http requests. When a request starts, we set the loadingSub property
 * in the LoadingService to true. Once the request completes and we have a response, set the loadingSub
 * property to false. If an error occurs while servicing the request, set the loadingSub property to false.
 */
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  permittedVerbs: string[] = ['HEAD', 'OPTIONS', 'TRACE'];

  constructor(
    private cookieService: CookieService,
    private translocoService: TranslocoService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Adding X-XSRF-TOKEN header //
    request = this.addToken(request);

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.setLanguage(event.headers.get('content-language') || Cultures.EnUs);
        }
      }),
      catchError((error) => throwError(() => error))
    );
  }

  private addToken(request: HttpRequest<any>) {
    const xsrfToken = this.getToken();
    xsrfToken !== null &&
      this.sendToken(request.method) &&
      (() => {
        request = request.clone({
          withCredentials: true,
          headers: request.headers.set('X-XSRF-TOKEN', xsrfToken),
        });
      })();
    return request;
  }

  private getToken = () => this.cookieService.get('XSRF-TOKEN');

  private sendToken = (requestMethod: string) =>
    this.permittedVerbs.findIndex(
      (x) => requestMethod.toLocaleUpperCase() === x
    ) === -1;

  private setLanguage = (lan: string) => this.translocoService.setActiveLang(lan) ;

}
